<template>
    <div class="main-container">
        <inner-navigation class="grid-order-1" link="/ai/chat" title="AI" imgURL="ai.png" navStyle=1></inner-navigation>
        <inner-navigation class="grid-order-2" link="/ai/collaborative-chat" title="Proje Yönetimi" imgURL="ai-project.png" navStyle=1></inner-navigation>
    </div>
</template>

<script>

import InnerNavigation from "../InnerNavigation.vue"


export default {
  name: 'CRMHome',
  components: {
      InnerNavigation: InnerNavigation
  },
}
</script>

<style scoped lang="scss">
  
  @import "../../styles/core/variables.scss";
  @import "../../styles/core/resets.scss";
  @import "../../styles/global/background.scss";
  @import "../../styles/global/helpers.scss";

</style>
